import { useState } from 'react'

import {
  clearBirdviewStoredLayout,
  getBirdviewLayoutStorageKeys,
  getBirdviewStorageKey,
} from '../../DashboardBirdview.utils.storage'

export function useBirdviewLayoutReset({
  isAnalyticsView,
  storageScope,
  onReset,
}) {
  const [layoutToken, setLayoutToken] = useState(0)

  // The boards read the stored layout once, so a reset has to remount them.
  function handleResetLayout() {
    clearBirdviewStoredLayout(
      getBirdviewLayoutStorageKeys({ isAnalyticsView, storageScope })
    )
    onReset()
    setLayoutToken(token => token + 1)
  }

  return {
    handleResetLayout,
    layoutKey: getBirdviewStorageKey(storageScope, [layoutToken]),
  }
}
